<div class="list-group">
  @for (
    ref of evidence
      | slice
        : (paginated ? (page - 1) * pageSize : 0)
        : (paginated ? page * pageSize : evidence.length);
    track ref;
    let idx = $index
  ) {
    <label
      class="list-group-item"
      [attr.for]="'fact-' + idx"
      [class.cursor-pointer]="selectable">
      <div class="d-flex gap-2">
        @if (selectable) {
          <input
            class="form-check-input"
            type="checkbox"
            [attr.id]="'fact-' + idx"
            [formControl]="evidenceControlCitationMap.get(ref.citation)" />
        }
        <h5>
          {{ ref.citation }}.
          @if (ref.url) {
            Source:
            <a [href]="ref.url" target="_blank">{{ ref.url | shortDomain }}</a>
          } @else {
            Input source {{ ref.citation }}
          }
        </h5>
      </div>

      <ng-template #evidenceContentTemplate>
        <app-short-content
          [content]="ref.content"
          [length]="shortContent || !ref.url ? 200 : ref.content.length" />
      </ng-template>

      @if (ref.content && ref.url) {
        <strong>Summary:</strong>
      }

      <ng-container
        *ngIf="ref.content"
        [ngTemplateOutlet]="evidenceContentTemplate"></ng-container>
      <div>
        @if (ref.word_count) {
          <strong>Words:</strong>
          {{ ref.word_count }}
        }
      </div>
    </label>
  }
</div>
@if (paginated) {
  <ngb-pagination
    [(page)]="page"
    [pageSize]="pageSize"
    [collectionSize]="evidence.length"
    class="d-flex justify-content-center" />
}
